export const INCLUDE_DEV_FEE_OPTIONS = [
    { label: 'No', value: false },
    { label: 'Yes', value: true },
];

export const FEE_TYPE_OPTIONS = [
    { label: '% of development cost', value: 'development_cost_percentage' },
    { label: '% of LP equity', value: 'equity_percentage' },
];
